import i18n from "../i18n";

const errorsKeyPattern = /^errors\.(.+)$/;

/**
 * Returns a user-facing error message for API errors.
 * Priority:
 *   1. error.key           → translate via common:errors.{key}
 *   2. error.message matching "errors.KEY" pattern → extract key, translate
 *   3. error.message as-is (already human-readable)
 *   4. default fallback
 * @param {string|{ message?: string, key?: string }} error
 * @returns {string}
 */
export default function getErrorMessage(error) {
  if (!error) return i18n.t("common:errors.default");
  if (typeof error === "string") return error;

  // An API error body can put a non-string in message; returning it verbatim is
  // what renders "[object Object]" in the toast.
  const message = typeof error.message === "string" ? error.message : null;

  const key = error.key || (errorsKeyPattern.exec(message ?? "") || [])[1];
  if (key) {
    return i18n.t(`common:errors.${key}`, {
      defaultValue: i18n.t("common:errors.default"),
    });
  }

  return message || i18n.t("common:errors.default");
}
